import { IApiEpBillingPaymentProvider, IApiEpBillingProduct } from "@smp/api";
import { useMemo } from "react";

import { IContextApp, useContextApp } from "@/screens/app/context/app";

export type IInvoiceFormValues = {
  paymentType: IContextApp["state"]["billingPaymentType"];
  paymentProvider: IApiEpBillingPaymentProvider | undefined;
  product: IApiEpBillingProduct;
  isInternalAccountUse: boolean;
};

export const useInvoiceForm = (product: IApiEpBillingProduct) => {
  const {
    state: { billingPaymentType, me },
  } = useContextApp();

  const initialValues = useMemo<IInvoiceFormValues>(() => {
    const paymentType =
      product.type === "plan-product" &&
      product.is_recurring_payment_allowed &&
      billingPaymentType === "recurring"
        ? "recurring"
        : "single";

    return {
      paymentType,
      paymentProvider: undefined,
      product,
      isInternalAccountUse: false,
    };
  }, [billingPaymentType, product]);

  const isPaymentSelectorAllowed = useMemo(
    () =>
      product.type === "plan-product" &&
      !["europe", "cis", "world"].includes(me.billing_policy_id),
    [me.billing_policy_id, product.type],
  );

  return useMemo(
    () => ({
      initialValues,
      isPaymentSelectorAllowed,
    }),
    [initialValues, isPaymentSelectorAllowed],
  );
};
